"use strict";

function asyncGeneratorStep(t, n, e, r, o, c, a) {
    try {
        var u = t[c](a),
            i = u.value
    } catch (t) {
        return void e(t)
    }
    u.done ? n(i) : Promise.resolve(i).then(r, o)
}

function _asyncToGenerator(t) {
    return function() {
        var n = this,
            e = arguments;
        return new Promise((function(r, o) {
            var c = t.apply(n, e);

            function a(t) {
                asyncGeneratorStep(c, r, o, a, u, "next", t)
            }

            function u(t) {
                asyncGeneratorStep(c, r, o, a, u, "throw", t)
            }
            a(void 0)
        }))
    }
}

function updateCartIcon() {
    return _updateCartIcon.apply(this, arguments)
}

function _updateCartIcon() {
    return (_updateCartIcon = _asyncToGenerator((function*() {
        let t = document.querySelector("[data-cart-item-count]");
        if (t) try {
            const n = yield fetch("/cart.js"), e = yield n.json();
            t.innerHTML = e.item_count
        } catch (t) {
            console.log(t)
        }
    }))).apply(this, arguments)
}
//# sourceMappingURL=cart-update.js.map